<template>
  <iv-spin
    v-if="empty || loading"
    size="large"
    fix
  >
    <iv-icon :type="loading?'ios-loading':(icon||'ios-filing-outline')" :size="size" />
    <div v-if="loading">{{ loadingCaption }}</div>
    <div v-else>{{ emptyCaption }}</div>
  </iv-spin>
</template>
<script>
export default {
  props: {
    empty: Boolean,
    loading: Boolean,
    icon: {
      type: String,
      defalut: 'ios-filing-outline'
    },
    size: {
      type: String,
      default: '48'
    },
    emptyCaption: {
      type: String,
      default: '暂无数据'
    },
    loadingCaption: {
      type: String,
      default: '加载中'
    }
  }
}
</script>
<style lang="postcss" scoped>
.ivu-icon-ios-loading{
    animation: loading 1s linear infinite;
}
@keyframes loading {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
}
</style>
